export default __webpack_public_path__ + "static/media/1.656d1a90.jpg";